import React from 'react'
import * as Comp from '../../app/features/support';
import * as Style from './style';
const Support = () => {
    return (
        <Style.Section>
            <Comp.Header />
            <Style.Content>
                <Comp.RightSection />
                <Comp.LeftSection />
            </Style.Content>

        </Style.Section>
    )
}

export default Support